import axios from "axios";
import { getSessionId } from "../../../utils/tokenHandlers";

export const getBusinessNameFromPan = (pan: string) => {
  const sessionid = getSessionId();
  return axios
    .post(
      `${process.env.REACT_APP_BASE_URL}fetch/pan/details`,
      {
        params: {
          karza_key: "47QlOJ9cG9A0QNH",
          pan_number: `${pan}`,
        },
      },
      {
        headers: {
          Authorization: `Bearer ${sessionid}`,
        },
      }
    )
    .then((response): any => response)
    .catch((err) => err);
};
